import { inject } from 'aurelia-framework';
import { Redirect } from 'aurelia-router';
import { BrowserStorageService } from './Advertiser.SharedPortal/services/browser-storage-service';

var configEnv = require('../config');

@inject(BrowserStorageService)
export class App {
    constructor(browserStorage) {
        this.browserStorage = browserStorage;

        this.year = new Date().getFullYear();
    }

    determineActivationStrategy() {
        return activationStrategy.invokeLifecycle;
    }

    configureRouter(config, router) {
        this.router = router;
        this.router.auth = true;
        var firstName = this.browserStorage.getItem('firstName');
        var noUser = '';

        if (!firstName) {
            firstName = noUser;
            this.router.auth = false;
        }

        var roles = this.browserStorage.getItem('custom:roles');
        if (roles) {
            roles = JSON.parse(roles);

            if (roles.role == 'Admin') {
                this.router.admin = true;
            }
        }

        this.router.firstName = firstName;

        var authorizeStep = {
            run: (navigationInstruction, next) => {
                if (navigationInstruction.config.admin && !this.router.admin) {
                    return next.cancel(new Redirect('not-authorized'));
                }

                if (
                    navigationInstruction.getAllInstructions().some(i => {
                        return i.config.auth;
                    })
                ) {
                    if (!this.router.auth) {
                        return next.cancel(new Redirect('not-authorized'));
                    }
                }

                return next();
            }
        };

        config.addAuthorizeStep(authorizeStep);
        config.title = 'delty';
        config.map([
            {
                route: '',
                moduleId: PLATFORM.moduleName('home'),
                name: 'home',
                title: 'home',
                nav: false,
                auth: false,
                settings: { isParent: false }
            },
            {
                route: configEnv.adminPortalUrl + '/advertisers',
                redirect: true,
                name: 'adminPortalReturn',
                title: 'Admin Portal',
                nav: true,
                auth: true,
                settings: { isParent: false, admin: true }
            },
            {
                route: 'null',
                moduleId: PLATFORM.moduleName('Advertiser.SharedPortal/pages/null'),
                name: 'User',
                title: firstName,
                nav: true,
                auth: false,
                settings: { isParent: true, userMenu: true }
            },
            {
                route: ['login', 'login/:emailaddress'],
                moduleId: PLATFORM.moduleName('user/login'),
                name: 'login',
                title: 'Log In',
                nav: firstName == noUser,
                auth: false,
                settings: { isParent: false, parentMenu: firstName }
            },
            {
                route: 'change-password',
                moduleId: PLATFORM.moduleName('user/change-password'),
                name: 'change-password',
                title: 'Change Password',
                nav: firstName != noUser,
                auth: true,
                settings: { isParent: false, parentMenu: firstName }
            },
            {
                route: 'logout',
                moduleId: PLATFORM.moduleName('user/logout'),
                name: 'logout',
                title: 'Logout',
                nav: firstName != noUser,
                auth: true,
                settings: { isParent: false, parentMenu: firstName }
            },
            {
                route: 'forgot-password',
                moduleId: PLATFORM.moduleName('user/forgot-password'),
                name: 'forgot-password',
                title: 'Forgot Password',
                nav: false,
                auth: false,
                settings: { isParent: false }
            },
            {
                route: ['confirm-forgot-password', 'confirm-forgot-password/:deltycode'],
                moduleId: PLATFORM.moduleName('user/confirm-forgot-password'),
                name: 'confirm-forgot-password',
                title: 'Confirm Forgot Password',
                nav: false,
                auth: false,
                settings: { isParent: false }
            },
            {
                route: [
                    'user-confirmation/:code/:email/:password',
                    'user-confirmation/:code/:email/:password/:showhiddenfields'
                ],
                moduleId: PLATFORM.moduleName('user/user-confirmation'),
                name: 'user-confirmation',
                title: 'Confirmation',
                nav: false,
                auth: false,
                settings: { isParent: false }
            },
            {
                route: ['user-registration'],
                moduleId: PLATFORM.moduleName('user/user-registration'),
                name: 'user-registration',
                title: 'Registration',
                nav: false,
                auth: true,
                admin: true,
                settings: { isParent: false }
            },
            {
                route: ['manage-users'],
                moduleId: PLATFORM.moduleName('user/manage-users'),
                name: 'manage-users',
                title: 'Manage Users',
                nav: false,
                auth: true,
                admin: true,
                settings: { isParent: false }
            },
            {
                route: configEnv.adminPortalUrl + '/logged-in',
                redirect: true,
                name: 'adminPortalLoggedIn',
                title: 'Admin Portal Logged In',
                nav: false,
                auth: true,
                settings: { isParent: false }
            },
            {
                route: configEnv.advertiserPortalUrl + '/logged-in',
                redirect: true,
                name: 'advertiserPortalLoggedIn',
                title: 'Advertiser Portal Logged In',
                nav: false,
                auth: true,
                settings: { isParent: false }
            },
            {
                route: configEnv.publisherPortalUrl + '/logged-in',
                redirect: true,
                name: 'publisherPortalLoggedIn',
                title: 'Publisher Portal Logged In',
                nav: false,
                auth: true,
                settings: { isParent: false }
            },
            {
                route: 'lightbox',
                moduleId: PLATFORM.moduleName('Advertiser.SharedPortal/lightbox/lightbox'),
                name: 'lightbox',
                title: 'lightbox',
                nav: false,
                settings: { isParent: false }
            },
            {
                route: 'not-authorized',
                moduleId: PLATFORM.moduleName('user/not-auth'),
                name: 'not-authorized',
                title: 'Not Authorized',
                nav: false,
                auth: false,
                settings: { isParent: false }
            },
            {
                route: 'not-found',
                moduleId: PLATFORM.moduleName('Advertiser.SharedPortal/pages/not-found'),
                name: 'not-found',
                title: 'Not Found',
                nav: false,
                settings: { isParent: false }
            },
            {
                route: ['reset-password/:deltycode/:email'],
                moduleId: PLATFORM.moduleName('user/reset-password'),
                name: 'reset-password',
                title: 'Reset Password',
                nav: false,
                auth: false,
                settings: { isParent: false }
            }
        ]);

        config.mapUnknownRoutes('Advertiser.SharedPortal/pages/not-found');
    }
}

